<script>
export default {
  props: {
    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<template>
  <svg
    aria-label="Herz-Symbol"
    viewBox="0 0 104 99"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
    "
  >
    <g transform="matrix(1,0,0,1,480.99,97.1648)">
      <g transform="matrix(1,0,0,1,147.818,-237)">
        <g transform="matrix(5.9375,0,0,5.9375,-636.23,129.908)">
          <path
            d="M2.313,9.664C1.409,6.842 2.466,3.617 5.428,2.663C6.986,2.16 8.706,2.457 10.001,3.431C11.227,2.484 13.01,2.164 14.566,2.663C17.528,3.617 18.591,6.842 17.688,9.664C16.282,14.136 10.001,17.581 10.001,17.581C10.001,17.581 3.767,14.188 2.313,9.664Z"
            :style="`fill: none; stroke: ${color}; stroke-width: 1.5px`"
          />
        </g>
      </g>
      <g transform="matrix(1,0,0,1,147.818,-237)">
        <g transform="matrix(5.9375,0,0,5.9375,-636.23,129.908)">
          <path
            d="M13.37,5.539C14.271,5.83 14.908,6.635 14.985,7.579"
            :style="`fill: none; stroke: ${color}; stroke-width: 1.5px`"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
